export const disputeResolution = () => {
  return [
    { text: '     19. DISPUTE RESOLUTION', bold: true, style: 'p', },

    { text: "     Having entered into this Agreement in good faith, and for their own respective business purposes, the Parties agree that it is in their own best and mutual interests that any dispute related to the terms of, performance of or claims under this Agreement with respect to the application, interpretation and/or breach of any term, duty or obligation of and under this Agreement, including, without limitation, any claim by Independent Contractor, its employees, agents, servants and/or contractors, including any person performing transportation functions for Independent Contractor, that any one of them claims to be and/or is determined to be an employee of Company, the Parties herewith agree, for themselves and/or any employee or agent, to resolve any such dispute (“Dispute”) only in accordance with and solely under the following procedures:", style: 'p' },

    {
      text: [
        { text: '     19.1.', bold: true, },
        { text: " Principal Amount In Dispute Does Not Exceed $10,000 Where the principal amount in dispute does not exceed $10,000, exclusive of interest, and legal costs and fees, the Parties agree that the Sacramento Superior Court, Small Claims Division, shall have exclusive jurisdiction over the Dispute.", style: 'p' },
      ],
      style: 'p',
      margin: [40, 0, 0, 10],
    },

    {
      text: [
        { text: '     19.2.', bold: true, },
        { text: " Principal Amount In Dispute Exceeds $10,000 Where the principal amount in dispute exceeds $10,000, exclusive of interest, and legal costs and fees, the Parties agree the Dispute shall be subject to the following procedures:", style: 'p' },
      ],
      style: 'p',
      margin: [40, 0, 0, 10],
    },

    {
      text: [
        { text: '     19.2.1.', bold: true, },
        { text: " Meet and Confer; Mediation. Either Party may give written notice to the other regarding the existence of a Dispute to conduct a meeting and confer sessions(s) between them (the “Meet and Confer” process). Within the thirty (30) days following the date of receipt of such notice by the other party, an authorized representative of each of the Parties having full settlement authority shall meet and confer at least once in an effort to resolve the Dispute informally. If such effort fails to mutually resolve the Dispute between them, either Party may request, and the other Party shall participate in, a procedure whereby the Dispute is submitted to an experienced mediator upon terms as may be mutually agreeable to the Parties to conduct a mediation (“Mediation”) between the Parties for such time as necessary to implement and complete such Mediation (“Mediation Period”).", style: 'p' },
      ],
      style: 'p',
      margin: [40, 0, 0, 10],
    },

    {
      text: [
        { text: '     19.2.2. Arbitration.', bold: true, },
        { text: ` If after the expiration of the thirty (30)-day Meet and Confer or the Meditation Period, whichever is later, the subject Dispute is not resolved, the Parties shall submit the Dispute for final and binding arbitration ("Arbitration") through and before JAMS (Judicial and Mediation Service), under the rules set forth by JAMS, before a single arbitrator ("Arbitrator") with appropriate subject matter expertise. The award of the Arbitrator may be enforced in any court of competent jurisdiction.`, style: 'p' },
      ],
      style: 'p',
      margin: [40, 0, 0, 10],
    },

    {
      text: [
        { text: '     19.2.3. Selection of Arbitrator', bold: true, },
        { text: " If the Parties are unable to mutually agree on an Arbitrator, the Parties shall each submit to the other a list of acceptable and qualified arbitrators in order of preference. The first common name to appear on both of the lists shall be appointed the Arbitrator. The Arbitrator shall be reimbursed all expenses and compensated at his or her standard rate for such purposes. It is the intent of the Parties that the Arbitration shall resolve any and all Disputes between the Parties. Any Party may apply to the Arbitrator seeking injunctive relief until the Arbitration award is rendered or the controversy is otherwise resolved. Any Party also may, without waiving any remedy under this Agreement, seek from any court having jurisdiction any interim, extraordinary, injunctive or provisional relief that is necessary to protect the rights or property of that Party pending the Arbitration.", style: 'p' },
      ],
      style: 'p',
      margin: [40, 0, 0, 10],
    },

    { text: '     19.2.4. Authority of Arbitrator', bold: true, style: 'p', margin: [40, 0, 0, 10] },


    {
      text: [
        { text: '     19.2.4.1.', bold: true, },
        { text: " Subject of Section", style: 'p' },
      ],
      style: 'p',
      margin: [60, 0, 0, 10],
    },

    {
      text: [
        { text: '     19.2.4.2.', bold: true, },
        { text: " above, the Arbitrator shall have the sole power to order the Parties to present evidence, including documents or testimony that the Arbitrator deems necessary to the rendering of a fair and equitable decision. The Arbitrator shall have the final judgment, in accordance with California law, as to what evidence and testimony to permit to be entered in the proceeding and the weight to be accorded each.", style: 'p' },
      ],
      style: 'p',
      margin: [60, 0, 0, 10],
    },

    {
      text: [
        { text: '     19.2.4.3.', bold: true, },
        { text: " The Arbitrator shall have no power to award punitive damages and any arbitration award of damages hereunder to either Party shall be limited to actual damages.", style: 'p' },
      ],
      style: 'p',
      margin: [60, 0, 0, 10],
    },

    {
      text: [
        { text: '     19.2.4.4.', bold: true, },
        { text: " The Parties expressly agree that this Agreement shall confer no power or authority upon the Arbitrator to render any judgment or award that is erroneous in its application of the terms of this Agreement or substantive law.", style: 'p' },
      ],
      style: 'p',
      margin: [60, 0, 0, 10],
    },

    {
      text: [
        { text: '     19.2.4.5.', bold: true, },
        { text: " The Arbitrator shall render the award in writing and, unless both Parties agree otherwise, shall include an explanation of the reasons for the award, which explanation may be limited to matters necessary to support the award and need not attempt to cover all issues raised by the Parties.", style: 'p' },
      ],
      style: 'p',
      margin: [60, 0, 0, 10],
    },

    {
      text: [
        { text: '     19.2.4.6.', bold: true, },
        { text: " The Parties expressly agree and acknowledge that the assigned Arbitrator shall have absolute authority to determine whether any Dispute hereunder is arbitrable under this Section 19.", style: 'p' },
      ],
      style: 'p',
      margin: [60, 0, 0, 10],
    },

    {
      text: [
        { text: '     19.2.5. Equitable Relief.', bold: true, },
        { text: " The Arbitrator shall have the power to order equitable relief, including protection of the status quo pending the completion of the Arbitration and the issuance of the decision. Pending the settlement of the Dispute by voluntary means pursuant to paragraph 19.1 or the appointment of an Arbitrator under paragraph 19.2, either Party may go to a court of competent jurisdiction to seek equitable relief, including a temporary injunction or restraining order. Upon the appointment of the Arbitrator, any relief granted by the court shall remain in effect until reversed or removed by the Arbitrator or until a final Arbitration decision is issued and entered.", style: 'p' },
      ],
      style: 'p',
      margin: [40, 0, 0, 10],
    },

    {
      text: [
        { text: '     19.2.6. Waiver.', bold: true, },
        { text: " For purposes of Section 19, and to assure that the terms hereof shall be and are the sole remedy available to either Party as to any Dispute hereunder, each of the Parties hereto represent, covenant and warrant to the other that each of them hereby mutually and voluntarily waive and will not participate as a Party in or to any class action proceeding which is in any manner contrary to the purpose of Section 19 that all Disputes of any nature between the Parties shall be resolved and determined in accordance with the provisions of Section 19. In the event that either Party shall breach this or any other term of Section 19, then such Party is and shall be required to reimburse the other Party for any and all costs, including attorneys' fees, related to having to enforce the rights and obligations of Section 19.", style: 'p' },
      ],
      style: 'p',
      margin: [40, 0, 0, 10],
    },

    {
      text: [
        { text: '     19.2.7. Confidentiality.', bold: true, },
        { text: " The Parties agree that any Meet and Confer, Mediation and/or Arbitration shall be subject to the confidentiality privileges and protections afforded settlement discussions and/or proceedings provided to the Parties under California laws, including but not limited to, those provisions set forth in Cal. Evid. Code §§ 1115, et seq., and 1150, et seq.", style: 'p' },
      ],
      style: 'p',
      margin: [40, 0, 0, 10],
    },
  ]
}